export default {
  projectTypes: [],
  projectTypeCode: null,

  projects: [],
  project: {},
  projectId: null,
  projectCode: null,

  workDescriptions: [],
  workDescriptionCode: null,

  projectTeams: [],

  generalEstimates: [],

  buildingProject: {},

  suites: [],
  suitCode: null,
  suiteId: null,

  units: [],
  unitCode: null,

  participation: [],
  participationCode: null,
  participationId: null,

  paymentNotification: [],
  paymentNotificationCode: null,

  rank: [],
  rankCode: null,

  estimation: [],
  estimationCode: null,
  estimationItem: {},
  estimationId: null,

  transfer: [],
  transferCode: null,

  crimesReward: [],
  crimesRewardCode: null,

  crimesRewardSubject: [],
  crimesRewardSubjectCode: null,

  estimationSubject: [],
  estimationSubjectCode: null,

  setting: [],

  blocks: [],
  blockCode: null,

  rankingReport: [],
  rankingDetailReport: [],

  smsSetting: [],
  sendSms: [],

  paymentNotificationLog: [],

  memberDeposits: [],
  memberDepositCode: null,
  memberDepositCartable: [],
  participationNotifications: {},

  hamsazOffsets: [],
  hamsazOffsetCode: null,
  hamsazOffsetBalance: null,
  hamsazOffsetCartable: [],
  hamsazOffsetVoucher: null,

  transferCartable: [],
  transferVoucher: null,
};
